import { useEffect, useState } from 'react';
import { useCnpjAlphanumeric } from '@ibk/shared-ui';
import { formatAsRegionalPhoneCode } from '@ibk/shared-utils';
import { BillType, PixType as PixTypeEnum } from '../../enums';
import { formatPixKeyByKeyTypeAlphanumeric, removeFormatOfPixKeyByKeyTypeAlphanumeric } from '../../utils/formatPixKey';
import { toPixKeyType } from '../../utils/pixKeyUtils';
import { usePatchPaymentDetails } from '../usePatchPaymentDetails';
import { usePostPaymentDetails } from '../usePostPaymentDetails';
export function usePostOrPatchPaymentDetails() {
    const { isValidCnpj, maskCnpj, unmaskCnpj } = useCnpjAlphanumeric();
    const { postPaymentDetails, error: postPaymentDetailsError, paymentDetails: postPaymentDetailsPaymentDetails, } = usePostPaymentDetails();
    const { patchPaymentDetails, error: patchPaymentDetailsError, paymentDetails: patchPaymentDetailsPaymentDetails, } = usePatchPaymentDetails();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [paymentDetails, setPaymentDetails] = useState();
    useEffect(() => {
        if (postPaymentDetailsPaymentDetails) {
            setPaymentDetails(postPaymentDetailsPaymentDetails);
            setLoading(false);
        }
    }, [postPaymentDetailsPaymentDetails]);
    useEffect(() => {
        if (patchPaymentDetailsPaymentDetails) {
            setPaymentDetails(patchPaymentDetailsPaymentDetails);
            setLoading(false);
        }
    }, [patchPaymentDetailsPaymentDetails]);
    useEffect(() => {
        if (postPaymentDetailsError || patchPaymentDetailsError) {
            setError(postPaymentDetailsError || patchPaymentDetailsError);
            setLoading(false);
        }
    }, [postPaymentDetailsError, patchPaymentDetailsError]);
    function postOrPatchPaymentDetails(body) {
        setLoading(true);
        setError(undefined);
        setPaymentDetails(undefined);
        const key = removeFormatOfPixKeyByKeyTypeAlphanumeric(body.keyType, body.pixKey, {
            isValidCnpj,
            maskCnpj,
            unmaskCnpj,
        });
        const pixKeyType = toPixKeyType(body.keyType, key, { isValidCnpj });
        const newCounterParty = {
            bank: body.financialInstitutionCode,
            branch: body.agencyNumber,
            account: body.accountNumber,
            accountType: body.accountType,
        };
        const keyToPersist = body.keyType === PixTypeEnum.PHONE ? formatAsRegionalPhoneCode(key) : key;
        const notAgencyKey = body.keyType === PixTypeEnum.RANDOM
            ? formatPixKeyByKeyTypeAlphanumeric(body.keyType, key, { isValidCnpj, maskCnpj, unmaskCnpj })
            : keyToPersist;
        const newPaymentDetails = {
            type: BillType.PIX,
            details: {
                keyType: pixKeyType,
                key: body.keyType !== PixTypeEnum.AGENCY ? notAgencyKey : undefined,
                counterparty: body.keyType === PixTypeEnum.AGENCY ? newCounterParty : undefined,
            },
        };
        if (body.id) {
            patchPaymentDetails(body.id, { paymentDetails: newPaymentDetails });
        }
        else {
            postPaymentDetails({
                party: body.party,
                documentNumber: body.document,
                documentType: body.documentType,
                paymentDetails: newPaymentDetails,
            });
        }
    }
    return {
        postOrPatchPaymentDetails,
        loading,
        setLoading,
        error,
        setError,
        paymentDetails,
        setPaymentDetails,
    };
}
